export const EventBus = {
    props: {
        localEventBus: {
            default: null
        }
    },
    data() {
        return {
            eventBus: this.localEventBus || new Vue(),
            lo: _
        };
    },
};
